import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { triangle } from 'polished';
import OpenArrow from '../../styled/header/open-indicator';

const HoverMenuStyle = styled.li`
  display: inline-block;
  padding-right: 14px;
  position: relative;
  padding-bottom: 8px;
`;

const HoverMenuContainer = styled.div`
  position: absolute;
  top: 35px;
  left: -75px;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transform-style: flat;
  z-index: 4;
  &:before {
    content: '';
    left: calc(50% - 9px);
    position: absolute;
    top: -9px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: '#ddd'
    })};
  }
  &:after {
    content: '';
    left: calc(50% - 9px);
    position: absolute;
    top: -8px;
    ${triangle({
      pointingDirection: 'top',
      width: '18px',
      height: '9px',
      foregroundColor: 'white'
    })};
  }
`;

const HoverMenuList = styled.ul`
  list-style: none;
  padding: 15px 20px;
  line-height: 1.9;
  margin-bottom: 0;
  border-bottom: 1px solid #ccc;
  padding-top: 10px;
  text-align: left;
`;

export default class HoverMenu extends Component {
  static propTypes = {
    menuItem: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    style: PropTypes.object,
    fancyArrow: PropTypes.bool
  };

  static defaultProps = {
    fancyArrow: true
  };

  state = {
    open: false
  };

  onMouseEnter = () => {
    this.setState({ open: true });
  };

  onMouseLeave = () => {
    this.setState({ open: false });
  };

  render() {
    const { menuItem, children, className, id, style, fancyArrow } = this.props;
    const { open } = this.state;
    // const open = true;
    return (
      <HoverMenuStyle
        id={id}
        className={`hover-menu ${className}`}
        style={style}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {menuItem} {fancyArrow && <OpenArrow open={open} />}
        <HoverMenuContainer
          className="hover-menu__container"
          style={{ display: open ? 'block' : 'none' }}
        >
          {children}
        </HoverMenuContainer>
      </HoverMenuStyle>
    );
  }
}
